import React, {useCallback, useEffect} from "react";
import { InputField, DropDown } from 'KN-EU-Broker-Dashboard-UI';
import { Grid, Icon, Checkbox, Popup} from 'semantic-ui-react';
import { reconTypeVal,actionTypeVal,importEntryLocVal,paymentTypeCodeVal } from '../../../constants';
import { useDispatch } from "react-redux";
import { updateCurrentJob } from '../../../slices/currentJobSlice';

const HeaderTabForm1 = ({formData, lowerEnv, onChange, onBlur, onSelect}) => {

    const dispatch = useDispatch();
    const {
      filerCode,
      reconciliationTypeCode,
      actionCode,
      importEntryLocationCode,
      brokerReferenceNumber,
      priorDisclosureIndicator,
      entryNumber
    } = formData;

    const checkboxClickMethod = useCallback((e, data)=>{
        const {name} = data;
        if(priorDisclosureIndicator === "Y")
          e.target.value="N";
        else
          e.target.value="Y";
        e.target.name=name;
        onChange(e);
        onBlur(e);
      }, [priorDisclosureIndicator])
    return ( 
        <Grid.Row>
        <Grid.Column>
          <DropDown 
            label='Reconciliation Type' 
            value={reconciliationTypeCode}
            name="reconciliationTypeCode"
            data={reconTypeVal}
            onChange={onSelect}
          />
        </Grid.Column>
        <Grid.Column>
          <DropDown 
            label='Action Type' 
            value={actionCode}
            name="actionCode"
            data={actionTypeVal}
            onChange={onSelect}
          />
        </Grid.Column>
        <Grid.Column>
          <DropDown 
          label='Import Entry Location' 
          value={importEntryLocationCode}
          data={importEntryLocVal}
          name="importEntryLocationCode"
          onChange={onSelect}
          />
        </Grid.Column>
        <Grid.Column>
          <InputField 
          label='Broker Reference Number' 
          value={brokerReferenceNumber}
          name="brokerReferenceNumber"
          onChange={onChange}
          onBlur={onBlur}
        />
        </Grid.Column>
        <Grid.Column>
          <InputField 
          label='Filer Code' 
          value={filerCode}
          name="filerCode"
          onChange={(e) => {
            dispatch(updateCurrentJob({filerCode: e.target.value}))
            onChange(e);
          }}
          isDisabled={lowerEnv[0] === 'prod'}
          onBlur={onBlur}
        />
        </Grid.Column>
        <Grid.Column>
          <InputField 
          label='Entry Number' 
          value={entryNumber}
          name="entryNumber"
          onChange={(e) => {
            dispatch(updateCurrentJob({entryNumber: e.target.value}))
            onChange(e);
          }}
          isDisabled={lowerEnv[0] === 'prod'}
          onBlur={onBlur}
        />
        </Grid.Column>
        <Grid.Column width='2'>
            <Checkbox
              label="Prior Disclosure Indicator"
              name="priorDisclosureIndicator"
              id="priorDisclosureIndicator"
              className="priorDisclosureIndicator"
              checked={priorDisclosureIndicator === "Y" ? true : false}
              onChange={checkboxClickMethod}
              color="red"
            />
            <Popup content='Prior disclosure has been made on one or more of the associated Entry Summaries' trigger={<Icon className="priorDisclosurIcon" name='info circle' />} />
          </Grid.Column>
      </Grid.Row>
     );
}
 
export default HeaderTabForm1;